/**
 * Frontend application settings cache.
 * Fetches arcgis_* service URLs from the backend once per session
 * and caches the result as a module-level promise (same pattern as
 * _arcgisTokenPromise in arcgisMapUtils.js).
 */

import axios from '../api/axiosConfig';

let _serviceUrlsPromise = null;

/**
 * Fetch service URLs from the backend and cache the promise.
 * On error, clears the cached promise so the next call retries.
 * @returns {Promise<Record<string, string>>}
 */
function fetchServiceUrls() {
  if (!_serviceUrlsPromise) {
    _serviceUrlsPromise = axios.get('/api/v1/service-urls')
      .then(res => res.data?.data || {})
      .catch(() => {
        _serviceUrlsPromise = null;
        return {};
      });
  }
  return _serviceUrlsPromise;
}

/**
 * Get a single service URL by setting key, with a hardcoded fallback.
 * @param {string} key - e.g. 'arcgis_mappluto_url'
 * @param {string} fallback - default URL if backend is unreachable or key missing
 * @returns {Promise<string>}
 */
export async function getServiceUrl(key, fallback) {
  const urls = await fetchServiceUrls();
  return urls[key] || fallback;
}
